<script setup lang="ts">
import { useSearchStore } from '../stores/search.store'
import { mdiCloseCircle, mdiHistory } from '@mdi/js'

import SvgIcon from '@/shared/components/icon/SvgIcon.vue'
import BaseButton from '@/shared/components/button/BaseButton.vue'
import PanelDivider from '@/shared/components/divider/PanelDivider.vue'

interface Emits {
  (e: 'click'): void
}

const emits = defineEmits<Emits>()

const searchStore = useSearchStore()

const onRemove = (term: string): void => {
  searchStore.removeRecentTerm(term)
}

const onApply = (term: string): void => {
  searchStore.searchQuery = term
  emits('click')
}
</script>

<template>
  <PanelDivider
    v-if="searchStore.recentTerms.length"
    :text="$t('glossary.recentSearch', 2)"
    class="text-gray-700 px-3 py-1"
  />
  <div
    v-for="term in searchStore.recentTerms"
    class="flex items-center justify-between py-1 px-3 cursor-pointer hover:bg-gray-100"
  >
    <div class="flex flex-1 items-center truncate" @click="onApply(term)">
      <SvgIcon :path="mdiHistory" class="fill-gray-700 h-5 w-5 me-1" />
      <span class="text-sm truncate">{{ term }}</span>
    </div>
    <BaseButton :title="$t('common.remove')" @click="onRemove(term)">
      <SvgIcon :path="mdiCloseCircle" class="fill-gray-700 h-5 w-5 mx-1" />
    </BaseButton>
  </div>
</template>
